import React, { Component } from 'react';

import GroupSettings from '../Groups/GroupSettings';

import { DropdownItem } from 'reactstrap';

import ReduxConnect from 'Demora/redux-connect';

import http from 'Demora/http';

import { withRouter } from 'react-router-dom';

import confirm from 'Demora/modals/confirm';

class GroupSettingsDropdownItem extends Component {
	leaveGroup = () => {
		confirm({
			id: 'leaveGroup',
			header: 'Leave Group',
			message:
				'Are you sure you want to leave the group ' +
				this.props.users[this.props.obj].first_name +
				' ' +
				this.props.users[this.props.obj].last_name +
				'?',
			confirmButtonText: 'Yes',
			confirmFunc: this.processLeaveGroup,
		});
	};

	processLeaveGroup = () => {
		let obj = this.props.obj;

		http
			.delete('/data/groups/leaveGroup/' + obj)
			.then((data) => {
				this.removeGroupFromRedux();
			})
			.catch((e) => {
				throw e;
			});
	};

	removeGroupFromRedux() {
		let f = { feed: {} };

		let obj = this.props.obj;

		f.feed[obj] = [];

		this.props.dispatch({
			type: 'STORE_FEED',
			data: f,
		});

		f.feed[obj] = {};

		this.props.dispatch({
			type: 'STORE_FEED',
			data: f,
		});

		this.props.history.push('/home');
	}

	render() {
		let props = this.props;

		let feed = props.feed[props.obj];

		let admin = parseFloat(feed.role) == 255;

		let out = [];

		if (admin) {
			out.push(
				<DropdownItem header key={1}>
					Admin
				</DropdownItem>
			);

			out.push(
				<DropdownItem key={2}>
					<GroupSettings obj={this.props.obj} />
				</DropdownItem>
			);
		}

		if (feed.creator != props.user.id && feed.role > 0) {
			out.push(
				<DropdownItem header key={3}>
					Leave Group
				</DropdownItem>
			);

			out.push(
				<DropdownItem key={4}>
					<div onClick={this.leaveGroup}>
						<i className='fas fa-door-open' /> Leave group
					</div>
				</DropdownItem>
			);
		}

		return out;
	}
}

export default withRouter(
	ReduxConnect(GroupSettingsDropdownItem, {
		feed: 'feed',
		users: 'users',
		user: 'user',
	})
);
